<template>
  <div class="container-370 text-center">
    <div class="main-title mt-40 mb-20">
      <p>会議の相手は？（必須）
        <a href="javascript: return void(0);" @click.stop="handleClickHelpModalOfUsers()">
          <img src="../../../assets/images/icon-question.png">
        </a>
      </p>
    </div>

    <el-select @change="handleChangeUserType"
               class="calendar-offline-select mb-15 w-370"
               placeholder="選択してください"
               v-model="userType"
    >
        <el-option v-for="item in USER_TYPES"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value"/>
    </el-select>

      <div v-if="userType !== null">
        <div v-if="users.items.length > 0" class="main-title mt-40 mb-20">
          <p v-if="userType === USER_TYPE_PATIENT">よく選択する患者はこちら</p>
          <p v-if="userType === USER_TYPE_PHARMACIST">よく選択する薬剤師はこちら</p>
          <p v-if="userType === USER_TYPE_OTHER">よく選択する多職種はこちら</p>
        </div>
        <ul class="list-option-sub-partner scroll-y-info margin-auto mt-0 text-left">
          <li
            :key="user.id"
            v-for="user in users.items"
            class="mb-1"
            :class="{selected: selectedUsers.findIndex(n => n.id === user.id) !== -1, 'cursor-not-allowed': selectedOtherUsers.findIndex(n => n.id === user.id) !== -1}"
          >
            <div
              class="p-15"
              @click="selectUser(user)"
              :class="{'stop-click': selectedOtherUsers.findIndex(n => n.id === user.id) !== -1}"
            >
              {{user.name}}
              <span v-if="user.type === USER_TYPE_OTHER">{{$auth.user().occupation}}</span>
            </div>
          </li>
        </ul>

        <div v-if="userType === USER_TYPE_PATIENT" class="main-title mt-40 mb-20"><p>他の患者を選択する？</p></div>
        <div v-else-if="userType === USER_TYPE_PHARMACIST" class="main-title mt-40 mb-20"><p>他の薬剤師を選択する？</p></div>
        <div v-else class="main-title mt-40 mb-20"><p>他の多職種を選択する？</p></div>

        <input @input="handleSearchInputChange" v-model="otherUsers.params.search_keywords" placeholder="名前,アカウント,ニックネーム,メルアド" id="input-search-other-users" type="text" class="input text margin-auto w-370 mt-10 mb-15 p-15">

        <ul  class="list-option-sub-partner mt-15 text-left">
          <li
            :key="user.id"
            v-for="user in otherUsers.items"
            class="mb-1"
            :class="{selected: selectedOtherUsers.findIndex(n => n.id === user.id) !== -1, 'cursor-not-allowed': selectedUsers.findIndex(n => n.id === user.id) !== -1, 'hidden': $auth.user().id === user.id}"
          >
            <div
              class="p-15"
              @click="selectOtherUser(user)"
              :class="{'stop-click': selectedUsers.findIndex(n => n.id === user.id) !== -1}"
            >
              {{user.name}}
            </div>
          </li>
          <li v-if="otherUsers.items.length === 0" class="no-items p-15">該当のユーザーが見つかりません</li>
          <infinite-loading @infinite="fetchOtherUsers" ref="fetchOtherUsers">
            <div slot="no-more"></div>
            <div slot="no-results"></div>
          </infinite-loading>
        </ul>

      </div>

    <div class="buttons-flex z-index-2 w-370 margin-auto">
      <a @click="next" class="button z-index-2 medium mt-40 flex-1 border-radius-22"
         :class="{disabled: [...value, ...selectedUsers, ...selectedOtherUsers].length === 0, info: [...value, ...selectedUsers, ...selectedOtherUsers].length > 0}"
      >
        {{`メンバーの確認（現在 ${[...selectedUsers, ...selectedOtherUsers].length}名）`}}
      </a>
    </div>
    <div class="buttons-flex z-index-2 w-370 margin-auto">
      <a @click="back" class="button z-index-2 default medium mt-15 flex-1 border-radius-22">
        戻る
      </a>
    </div>

    <div class="modal-overlay" v-if="showModal">
      <div class="modal">
        <div class="modal-header"></div>
        <div class="modal-body">
          <table class="pt-20 pb-20">
            <tbody>
              <tr>
                <th width="20%" valign="top" class="pb-20">患者：</th>
                <td align="left" class="pb-20 pr-20">自薬局で手帳発行済み、かつポケットミーティングの利用同意が得られている患者が検索可能です。</td>
              </tr>
              <tr>
                <th width="20%" valign="top" class="pb-20">薬剤師：</th>
                <td align="left" class="pb-20 pr-20">ポケットミーティングを利用したオンライン服薬指導・オンラインカンファレンスに対応している薬局に所属する薬剤師が検索可能です。</td>
              </tr>
              <tr v-if="false">
                <th width="20%" valign="top" class="pb-20">多職種：</th>
                <td align="left" class="pb-20 pr-20">（仮）ポケットミーティングを利用したオンライン服薬指導・オンラインカンファレンスに対応している薬局に登録している多職種ユーザーが検索可能です。</td>
              </tr>
            </tbody>
          </table>
          <p class="pb-20">
            <a href="javascript: return void(0);" @click.stop="handlecloseHelpModalOfUsers()" class="confirm-btn">閉じる</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import UsersApi from '@/api/users'
import {apiErrorDialog} from '@/helpers'
import {USER_TYPES, USER_TYPE_OTHER, USER_TYPE_PHARMACIST, USER_TYPE_PATIENT} from '@/const'

export default {
  props: {
    value: {type: Array, require: false},
    meeting: {type: Object, require: false}
  },
  data () {
    return {
      USER_TYPES,
      USER_TYPE_OTHER,
      USER_TYPE_PHARMACIST,
      USER_TYPE_PATIENT,
      userType: null,
      users: {items: [], params: {page: 1, limit: 10, recents_meeting: true}},
      otherUsers: {items: [], params: {page: 1, search_keywords: ''}},
      selectedUsers: [],
      selectedOtherUsers: [],
      showModal: false
    }
  },
  watch: {
    value: function () {
      let newSelectedUsers = []
      let newSelectedOtherUsers = []
      this.value.forEach(v => {
        this.selectedUsers.forEach(user => {
          if (v.id === user.id) newSelectedUsers.push(v)
        })
        this.selectedOtherUsers.forEach(otherUser => {
          if (v.id === otherUser.id) newSelectedOtherUsers.push(v)
        })
      })
      this.selectedUsers = newSelectedUsers
      this.selectedOtherUsers = newSelectedOtherUsers
    }
  },
  methods: {
    next () {
      const users = [...this.value, ...this.selectedUsers, ...this.selectedOtherUsers]
      if (users.length === 0) return
      this.$emit('input', _.uniqBy(users, 'id'))
      this.$emit('changeStep', 'confirm-users')
    },
    back () {
      this.$emit('changeStep', 'set-title', true)
    },
    async handleChangeUserType (val) {
      // const elm = document.getElementById('input-search-other-users')
      // elm.setAttribute('value', '')
      this.users = {items: [], params: {page: 1, limit: 5, recents_meeting: true}}
      this.otherUsers = {items: [], params: {page: 1, type: this.userType, search_keywords: ''}}
      if (this.$refs.fetchOtherUsers) this.$refs.fetchOtherUsers.stateChanger.reset()
      await this.fetchUsers()
    },
    selectUser (user) {
      if (_.findIndex(this.selectedUsers, n => n.id === user.id) === -1) {
        this.selectedUsers = [...this.selectedUsers, user]
      } else {
        _.remove(this.selectedUsers, n => n.id === user.id)
        this.selectedUsers = [...this.selectedUsers]
      }
    },
    selectOtherUser (user) {
      if (_.findIndex(this.selectedOtherUsers, n => n.id === user.id) === -1) {
        this.selectedOtherUsers = [...this.selectedOtherUsers, user]
      } else {
        _.remove(this.selectedOtherUsers, n => n.id === user.id)
        this.selectedOtherUsers = [...this.selectedOtherUsers]
      }
    },
    handleSearchInputChange: _.debounce(function (e) {
      this.otherUsers = {items: [], params: {page: 1, search_keywords: e.target.value}}
      this.$refs.fetchOtherUsers.stateChanger.reset()
    }, 500),
    async fetchUsers () {
      let params = {type: this.userType}
      params.from_pp = this.userType == USER_TYPE_PATIENT
      const res = await UsersApi.getRecents(params)
        .catch((error) => {
          apiErrorDialog(this, error)
        })
      this.users.items = res.data.data
    },
    async fetchOtherUsers ($state) {
      if (this.otherUsers.params.search_keywords.trim() !== '') {
        let params = {...this.otherUsers.params, type: this.userType}
        params.from_pp = this.userType == USER_TYPE_PATIENT
        const res = await UsersApi.get(params)
          .catch((error) => {
            apiErrorDialog(this, error)
          })
        const users = res.data.data
        const pagination = res.data.meta.pagination
        this.otherUsers.items = [...this.otherUsers.items, ...users]
        if (!pagination.has_more_pages) return $state.complete()
        this.otherUsers.params.page++
        $state.loaded()
      } else {
        $state.complete()
      }
    },
    handleClickHelpModalOfUsers () {
      this.showModal = true
    },
    handlecloseHelpModalOfUsers () {
      this.showModal = false
    }
  },
  async mounted () {
    this.selectedUsers = []
    this.selectedOtherUsers = []
    this.users = {items: [], params: {page: 1, limit: 5, recents_meeting: true}}
    this.otherUsers = {items: [], params: {page: 1, type: this.userType, search_keywords: ''}}
    if (this.$route.name === 'meetings.edit') {
      this.selectedUsers = this.meeting.participants
      for (let i = 0; i < this.selectedUsers.length; i++) {
        this.selectedUsers[i].id = this.selectedUsers[i].user_id
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/meetings/create/SelectUsers.vue